import { DialogProps } from '@fortem-monorepo/react-ui'
import { SubmitButton } from '@fortem-monorepo/react-ui'
import { Button } from '@fortem-monorepo/react-ui'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@fortem-monorepo/react-ui'

import { SendEmailsToClientsFormFields } from '@/components/forms/SendEmailsToClientsFormNew/SendEmailsToClientsFormFieldsNew'
import { SendEmailsToClientsForm } from '@/components/forms/SendEmailsToClientsFormNew/SendEmailsToClientsFormNew'

export interface SendEmailsToClientsModalProps extends DialogProps {}

export const SendEmailsToClientsModal: React.FC<SendEmailsToClientsModalProps> = ({ ...props }) => {
  return (
    <Dialog {...props}>
      <DialogContent className={'min-w-fit!'}>
        <SendEmailsToClientsForm>
          {({ formState: { isValid, isSubmitting } }) => {
            return (
              <>
                <DialogHeader>
                  <DialogTitle>Send Client Emails</DialogTitle>
                </DialogHeader>
                <div className="my-6">
                  <SendEmailsToClientsFormFields />
                </div>
                <DialogFooter>
                  <Button
                    type="button"
                    variant={'destructive'}
                    size="sm"
                    onClick={() => props.onOpenChange?.(false)}
                  >
                    Cancel
                  </Button>
                  <SubmitButton
                    disabled={!isValid || isSubmitting}
                    loading={isSubmitting}
                    size="sm"
                  >
                    Submit
                  </SubmitButton>
                </DialogFooter>
              </>
            )
          }}
        </SendEmailsToClientsForm>
      </DialogContent>
    </Dialog>
  )
}
